import {
  authDescriptorSchema,
  authorizationRequestResponseSchema,
  authorizationResponseSchema,
} from '@tempo-io/work-integration-dto';
import { tempoApi } from '@/common/api/tempoApi';
import type { WorkIntegration_Keys } from '@/common/api/types/workIntegrations';

const oauthClientBasePath = (provider: WorkIntegration_Keys) =>
  `api/v1/work-integration/${provider.toLowerCase()}/oauth-client`;

const request = async (
  provider: WorkIntegration_Keys,
  { returnUrl, instanceId }: { returnUrl: string; instanceId?: string },
) => {
  const response = await tempoApi()
    .post(`${oauthClientBasePath(provider)}/authorization-request`, {
      json: { returnUrl, instanceId },
    })
    .json();
  return authorizationRequestResponseSchema.parse(response);
};

const response = async (provider: WorkIntegration_Keys, { returnUrl }: { returnUrl: string }) => {
  const parsed = await tempoApi()
    .post(`${oauthClientBasePath(provider)}/authorization-response`, {
      json: { returnUrl },
    })
    .json();
  return authorizationResponseSchema.parse(parsed);
};

const getAuthDescriptor = async (provider: WorkIntegration_Keys) => {
  const parsed = await tempoApi()
    .get(`api/v1/work-integration/${provider.toLowerCase()}/auth-descriptor`)
    .json();
  return authDescriptorSchema.parse(parsed);
};

export const OAuthApi = {
  request,
  response,
  getAuthDescriptor,
} as const;
